const ns = "ITEMS_INVENTORY";
export const RECEIVE = `${ns}_RECEIVE`;
export const RECEIVE_PAGINATION = `${ns}_RECEIVE_PAGINATION`;
export const REQUEST = `${ns}_REQUEST`;
export const CLEAR_SEARCH = `${ns}_CLEAR_SEARCH`;
